import { render, staticRenderFns } from "./Financial_PartnerFees.vue?vue&type=template&id=1e6848b4&"
import script from "./Financial_PartnerFees.vue?vue&type=script&lang=js&"
export * from "./Financial_PartnerFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports